.emptyView {
	text-align: center;
	padding: 50px 10px 0 10px;
	margin: auto;
	height: 100%;
	overflow: hidden;
}
